import styled from 'styled-components';

import { ButtonBase } from '@material-ui/core';

export const Container = styled.div`
  padding: 20px 0px;
  background-color: #cce6ee;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 500px;

  span,
  svg {
    color: #0384ac;
  }

  .icon-infusion-kit {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 110px;
    margin: 0px 20px;
  }
`;

export const Content = styled.div`
  flex: 1;
  margin-right: 30px;
`;

export const DrugTitle = styled.p`
  font-size: 14px;
  font-weight: bold;
  color: #0384ac;
  margin-bottom: 12.5px;
`;

export const Detail = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 5px;
  /* background-color: red; */
`;

export const VideoButton = styled(ButtonBase)`
  display: flex !important;
  flex-direction: row;
  align-items: center;
`;

export const DetailText = styled.p`
  ${(props) =>
    props.bold &&
    `
    font-weight: bold;
  `}
  line-height: 10px;
  margin-left: 5px;
  font-size: 10px;
  color: #0384ac;
`;
